module.exports = __webpack_public_path__ + "img/P150T_weapon_147.7a25cfb5.png";